<template>

    <div class="user">
      <!--添加任务-->
      <div class="common-seach-wrap">
        <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
          <el-form-item label="做任务名称">
            <el-input placeholder="请输入做任务名称" v-model="formInline.search">
          
            </el-input>
          </el-form-item>

          <el-form-item >
            <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>

            <el-button type="primary" v-if="dotask_id > 0" icon="el-icon" @click="back">返回上一页</el-button>
          </el-form-item>
  
        </el-form>
      </div>
  

  
      <div class="product-content">
        <el-form ref="form" :model="form" label-width="100px">
          <div class="table-wrap">
            <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">

              <el-table-column prop="dotask.name" label="任务名称"></el-table-column>
              <el-table-column prop="dotask.intro" label="任务简介"></el-table-column>

              
              <el-table-column prop="code" label="任务类型">
                <template slot-scope="scope">
                  <span v-if="scope.row.dotask.code == 'common'">普通任务</span>
                  <span v-if="scope.row.dotask.code == 'sport'">微信运动任务</span>
                </template>
  
      
              </el-table-column>
              <el-table-column prop="dotask.point" label="任务奖励积分"></el-table-column>

              <el-table-column prop="note" label="用户">
                <template slot-scope="scope">
                    <div >ID：{{ scope.row.user.user_id }}</div>
                  <div>昵称：{{ scope.row.user.nickName }}</div>
                  <div >手机号：{{ scope.row.user.mobile }}</div>
   
                </template>
              </el-table-column>
  

              <el-table-column prop="note" label="用户提交任务备注">

                <template slot-scope="scope">
                  <div  style="height: 80px;width:210px; overflow-x:auto;" >{{ scope.row.note }}</div>
                 
                </template>
  
              </el-table-column>

              <el-table-column prop="status" label="审核状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.status == 0">未审核</span>
                  <span v-if="scope.row.status == 1">审核通过</span>
                  <span v-if="scope.row.status == 2">审核未通过</span>
                </template>
  
              </el-table-column>
              <el-table-column prop="reject_val" label="驳回理由"></el-table-column>

              <el-table-column prop="audit_time" label="审核时间" width="150"></el-table-column>

              <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
              <el-table-column fixed="right" label="操作" width="90">
                <template slot-scope="scope">
                  <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                  <el-button v-if="scope.row.status == 0" @click="editClick(scope.row)" type="text" size="small">审核</el-button>
                  <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form>
        <!--分页-->
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background
            :current-page="curPage"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="totalDataNumber"
          ></el-pagination>
        </div>
      </div>
      
      
      <Edit :open_add="open_edit" :dotask_log_id="dotask_log_id"  v-if="open_edit"   @close="closeEdit"></Edit>
  

    </div>
  </template>
  
  <script>
    import DotaskApi from '@/api/dotask.js';

    import Edit from './partl/edit.vue';
  
    export default {
      components: {
  
        Edit,
      },
      inject: ['reload'],
      data() {
        return {
          /*是否加载完成*/
          loading: true,
          /*列表数据*/
          tableData: [],
          /*一页多少条*/
          pageSize: 20,
          /*一共多少条数据*/
          totalDataNumber: 0,
          /*当前是第几页*/
          curPage: 1,
          /*搜索表单对象*/
          form: {},
          formInline: {
            search:"",
          },
  
          open_add:false,
          open_edit:false,
          dotask_log_id:"",
          dotask_id:0,

        };
      },
      created() {
        console.log(this.$route.query.dotask_id)
        if(this.$route.query.dotask_id){
          this.formInline.search = this.$route.query.dotask_id
          this.dotask_id = this.$route.query.dotask_id 
        }


        /*获取列表*/
        this.getTableList();
      }, 
      methods: {
        back(){
          this.$router.back(-1);
        },
    
         /*关闭添加*/
      closeAdd(e){
        this.open_add=false;
        this.getTableList();
      },
      closeEdit(e){
        this.open_edit=false;
        this.getTableList();
      },
      getData(){
        this.getTableList();
      },
        /*选择第几页*/
        handleCurrentChange(val) {
          this.curPage = val;
          this.getTableList();
        },
  
        /*每页多少条*/
        handleSizeChange(val) {
          this.curPage = 1;
          this.pageSize = val;
          this.getTableList();
        },
  
        /*获取列表*/
        getTableList() {
          let self = this;
          let Params = this.formInline;
          Params.page = self.curPage;
          Params.list_rows = self.pageSize;
          self.loading = true;
          DotaskApi.log(Params, true)
            .then(data => {
              self.loading = false;
              self.tableData = data.data.list.data;
              self.totalDataNumber = data.data.list.total;
            })
            .catch(error => {
            });
        },
  
    /*编辑活动*/
        editClick(row) {
            this.dotask_log_id = row.dotask_log_id;
            this.open_edit = true
        },
        /*搜索查询*/
        onSubmit() {
          this.curPage = 1;
          this.getTableList();
        },
           /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            DotaskApi.delLog(
              {
                dotask_log_id: row.dotask_log_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      }
  
      }
    };
  </script>
  
  <style></style>
  


// WEBPACK FOOTER //
// src/views/plus/dotask/index/log.vue